/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBinderClaimDetailDto
 */
export interface UpdateBinderClaimDetailDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimDetailDto
     */
    lossType: UpdateBinderClaimDetailDtoLossTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateBinderClaimDetailDto
     */
    outstanding100Layer?: string;
}


/**
 * @export
 */
export const UpdateBinderClaimDetailDtoLossTypeEnum = {
    Indemnity: 'Indemnity',
    LossAdjusterCosts: 'Loss Adjuster Costs',
    ConsultantCosts: 'Consultant Costs',
    LegalCosts: 'Legal Costs',
    RiCosts: 'RI Costs'
} as const;
export type UpdateBinderClaimDetailDtoLossTypeEnum = typeof UpdateBinderClaimDetailDtoLossTypeEnum[keyof typeof UpdateBinderClaimDetailDtoLossTypeEnum];


/**
 * Check if a given object implements the UpdateBinderClaimDetailDto interface.
 */
export function instanceOfUpdateBinderClaimDetailDto(value: object): value is UpdateBinderClaimDetailDto {
    if (!('lossType' in value) || value['lossType'] === undefined) return false;
    return true;
}

export function UpdateBinderClaimDetailDtoFromJSON(json: any): UpdateBinderClaimDetailDto {
    return UpdateBinderClaimDetailDtoFromJSONTyped(json, false);
}

export function UpdateBinderClaimDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBinderClaimDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lossType': json['lossType'],
        'outstanding100Layer': json['outstanding100Layer'] == null ? undefined : json['outstanding100Layer'],
    };
}

export function UpdateBinderClaimDetailDtoToJSON(json: any): UpdateBinderClaimDetailDto {
    return UpdateBinderClaimDetailDtoToJSONTyped(json, false);
}

export function UpdateBinderClaimDetailDtoToJSONTyped(value?: UpdateBinderClaimDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lossType': value['lossType'],
        'outstanding100Layer': value['outstanding100Layer'],
    };
}

